<template>
  <div id="base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style>
#base {
}
</style>
